<template>
 <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10 mb-5">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-3"
                >
                    DEFECTA
                </h1>
                <p class="text-center font-poppins text-sm">DAFTAR BARANG YANG KAMU PERLU STOCK ULANG<br/>DALAM SEMINGGU KEDEPAN</p>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-2 mx-auto">
                <TextInput
                    v-model="tglMasukData"
                    class="w-full mr-5"
                    id="cari_obat"
                    label="CARI OBAT"
                />
            </div>
            <div class="w-full md:w-1/2 mx-auto mb-5">
                <button
                    @click.prevent="searchObat()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center justify-center text-center ml-auto self-end px-6 py-3 text-xs"
                >
                    LIHAT
                </button>
            </div>
            <div class="w-full my-3">
                <div class="mb-3">
                    <button class="px-3 py-2  bg-pink-500 hover:bg-pink-700 rounded-xl text-white font-poppins text-sm">
                        AMBIL DATA
                    </button>
                </div>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm">No</th>
                                <th class="py-2 px-3 text-center text-sm">Kode Nama Barang</th>
                                <th class="py-2 px-3 text-center text-sm">Status Order</th>
                                <th class="py-2 px-3 text-center text-sm">Sisa Stok</th>
                                <th class="py-2 px-3 text-center text-sm">Stok Minimum</th>
                                <th class="py-2 px-3 text-center text-sm">Prioritas</th>
                                <th class="py-2 px-3 text-center text-sm">Rata2 laku/minggu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    1
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Kode Barang
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Status
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Sisa Stok
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Stok Minimum
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Prioritas
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Rata2 laku/minggu
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="7">
                                    Belum ada data
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import TextInput from "../../../Shared/TextInput.vue";

export default {
    components: {
        TextInput
    },
    layout: LayoutAdmin,
}
</script>